<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="900"
    >        
      <v-card >
        <v-card-title class="text-h5 blue darken-2 white--text" v-text="termsDetails.map_tc_description"></v-card-title>
        <v-card-text v-html="termsDetails.map_tc_text" class="mt-2"></v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="gray darken-1"
                text
                @click="$emit('close-dialog')"
            >
                Close
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'TermsAndConditionsDialog',
    props: {
        showDialog: Boolean,
        termsDetails: Object
    }
  }
</script>